import { PaperclipIcon } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  /** Имя вложения */
  name: string;
};

/**
 * Вложение, которое получить нельзя: имя и пометка «Ссылка недоступна», не открывается.
 * Не уместившись в облако, пометка уходит на следующую строку, а имя переносится, а не сокращается.
 */
export const UnavailableAttachment: FC<Props> = ({ name }) => {
  const { t } = useTranslation(['dialogs']);
  return (
    <span className="flex min-w-0 items-center gap-2 text-sm not-italic text-muted-foreground">
      <PaperclipIcon className="size-4 shrink-0" />
      <span className="flex min-w-0 flex-wrap items-baseline gap-x-2">
        <span className="min-w-0 wrap-break-word">{name}</span>
        <span className="shrink-0 text-xs">{t('dialogs:attachmentUnavailable')}</span>
      </span>
    </span>
  );
};
